import React from 'react';

const Card = ({ title, img, content, number, titleFullData,className }) => {
  return (
    <div className="flex justify-center" title={titleFullData}>
      <div className={`w-11/12 max-w-sm p-2 bg-white rounded-lg shadow-md md:p-4 md:max-w-md lg:max-w-lg${className}`}>
        <div className="flex items-center justify-between mt-0 md:mt-2">
          <h3 className="mb-2 text-sm font-bold md:text-base lg:text-lg inter500">{title}</h3>
          <span className="px-2 py-1 text-xs font-bold rounded-full md:text-sm lg:text-base">
            <img src={img} className="w-6 h-6 md:h-8 md:w-8 lg:h-10 lg:w-10" alt="img" />
          </span>
        </div>
        <p className="mb-2 text-sm font-bold md:text-3xl lg:text-4xl Dmsans700">{number}</p>
      </div>
    </div>
  );
};

export default Card;


// import React from 'react'



// const Card = ({ title, img, content, number,editableCompleted }) => {
//     return (
//         <div>
//             <div className="p-1 bg-white rounded-lg shadow-md md:p-4">
//                 <div className="flex items-center justify-between mt-0 md:mt-2">
//                     <h3 className="mb-2 text-sm font-bold md:text-base lg:text-lg inter500">{title}</h3>
//                     <span className="px-2 py-1 text-xs font-bold rounded-full md:text-sm lg:text-base">
//                         <img src={img} className="w-6 h-6 md:h-8 md:w-8 lg:h-10 lg:w-10" alt='img'/>
//                     </span>
//                 </div>
//                 <p className="mb-2 text-sm font-bold md:text-3xl lg:text-4xl Dmsans700">{number}</p> 
//             </div>
//         </div>

//     )
// }

// export default Card

